package com.essntl.features.price.data.repository

import com.essntl.core.supabase.getAll
import com.essntl.core.supabase.updateMany
import com.essntl.core.utils.repository.Repository
import com.essntl.features.price.data.supabase.proposalserviceprice.ProposalServicePriceDto
import com.essntl.features.price.data.supabase.proposalserviceprice.ProposalServicePriceSupabaseDataSource
import com.essntl.features.price.data.supabase.proposalserviceprice.toRequestMap
import com.essntl.features.price.domain.model.proposalserviceprice.ProposalServicePriceModel
import com.essntl.features.price.domain.repository.PriceRepository
import org.koin.core.annotation.Single

@Single(binds = [PriceRepository::class])
class PriceRepositoryImpl internal constructor(
    private val proposalServicePriceSupabaseDataSource: ProposalServicePriceSupabaseDataSource,
) : Repository(), PriceRepository {
    override suspend fun getPricesByProposalService(proposalServiceId: String): Result<List<ProposalServicePriceModel>> =
        runCatching {
            proposalServicePriceSupabaseDataSource
                .getAll(
                    columns = ProposalServicePriceDto.getColumns(),
                ) {
                    filter {
                        eq("proposal_service_id", proposalServiceId)
                    }
                }
                .map {
                    it.toModel()
                }
        }

    override suspend fun getPricesByProposalServices(proposalServiceIds: List<String>): Result<List<ProposalServicePriceModel>> =
        runCatching {
            proposalServicePriceSupabaseDataSource
                .getAll(
                    columns = ProposalServicePriceDto.getColumns(),
                ) {
                    filter {
                        or {
                            proposalServiceIds.forEach { id ->
                                eq("proposal_service_id", id)
                            }
                        }
                    }
                }
                .map {
                    it.toModel()
                }
        }

    override suspend fun updateProposalServicePrices(proposalServicePrices: List<ProposalServicePriceModel>): Result<List<ProposalServicePriceModel>> =
        runCatching {
            proposalServicePriceSupabaseDataSource
                .updateMany(
                    requestMapMap = proposalServicePrices.associateBy(
                        keySelector = { it.id },
                        valueTransform = { it.toRequestMap() },
                    ),
                    columns = ProposalServicePriceDto.getColumns(),
                ).map {
                    it.toModel()
                }
        }
}